import styled from "styled-components";
import { position, PositionProps } from "styled-system";

export const StyledAnchor = styled.a<PositionProps>`
	display: inline-flex;
	gap: ${({ theme }) => theme.space.xs};
	text-decoration: none;
	${position}
`;
